module.exports = __webpack_public_path__ + "br.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/br.svg
// module id = 464
// module chunks = 0